module.exports = __webpack_public_path__ + "img/egame_cq9.ade93fc7.png";